import GemShopComponent from "../componetns/menu/gem_shop/GemShopComponent";
import './Page.css';

function GemShop() {
    return (
        <div className="main_work_field">

            <GemShopComponent/>
        </div>
    );
}

export default GemShop;